import React, { ReactNode } from 'react';
import styles from './styles.scss';

export const ItpGlobalStyleWrapper = ({ children }: { children: ReactNode }) => (
  <div className={styles.itpStyleWrapper}>{children}</div>
);
